<template>
  <div class="container-fluid">
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="card card-top-line">
          <div class="header">
            <h2>Bin Listing</h2>
          </div>
          <div class="body pt-0">
            <div class="chart-top-action d-lg-flex justify-content-end py-2">
              <!-- SearchBox Filters -->
              <div class="mr-0 mr-lg-3 action-top-search">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Search Keyword"
                    aria-label="Search"
                    aria-describedby="search-transactions"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text" id="search-mail">
                      <i class="icon-magnifier"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div class="fliter-main mr-auto mt-3 mt-md-0">
                <b-button
                  class="fliter-btn btn-lg btn-mw"
                  :variant="isVisibleFilter ? 'primary' : 'outline-primary'"
                  @click="openFilters()"
                >
                  Filters
                  <i class="fa fa-filter" aria-hidden="true"></i>
                </b-button>
              </div>
              <div
                class="d-md-flex justify-content-between mt-lg-0 mt-md-3 mt-0"
              >
                <div
                  class="payment-dropdown d-flex flex-row-reverse ml-lg-3 mt-3 mt-sm-0"
                >
                  <router-link
                    class="btn btn-primary btn-mw btn-lg"
                    to="add-bin-listing"
                  >
                    Add New
                    <i class="fa fa-plus-square"></i>
                  </router-link>
                </div>
                <b-dropdown
                  class="ml-2"
                  id="download"
                  text="Download"
                  size="lg"
                  variant="outline-primary btn-mw"
                >
                  <template #button-content>
                    Download Report
                    <i class="fa fa-download"></i>
                  </template>
                  <b-dropdown-item href="">Export as PDF</b-dropdown-item>
                  <b-dropdown-item href="">Export as CSV</b-dropdown-item>
                </b-dropdown>
              </div>
              <b-collapse
                id="fliter-collapse"
                class="fliter-collapse"
                v-model="isVisibleFilter"
              >
                <div
                  class="d-flex flex-column justify-content-between pt-3 pr-3 pl-3 middleware-list-wrapper"
                >
                  <div
                    v-for="(item, index) in advanceFilters"
                    :key="index"
                    class="d-flex middleware-list"
                  >
                    <div
                      class="form-group form-select single-multiselect m-0 column-1"
                    >
                      <span class="float-label w-100">
                        <label>Select Field</label>
                        <multiselect
                          placeholder=""
                          v-model="item.field"
                          :show-labels="false"
                          :options="filterField"
                          label="name"
                          :searchable="true"
                          :allowEmpty="false"
                          @select="fieldsUpdate"
                        ></multiselect>
                      </span>
                      <div class="line"></div>
                    </div>
                    <div
                      class="form-group form-select m-0 single-multiselect column-2"
                      v-if="item.field && item.field.id == 'brand'"
                    >
                      <span class="float-label w-100">
                        <label for="transaction">Select Brand</label>
                        <multiselect
                          placeholder=""
                          v-model="item.search"
                          :show-labels="false"
                          :options="brandOptions"
                          :searchable="true"
                        ></multiselect>
                      </span>
                    </div>
                    <div
                      class="form-group form-select m-0 single-multiselect column-2"
                      v-if="item.field && item.field.id == 'type'"
                    >
                      <span class="float-label w-100">
                        <label for="transaction">Select Type</label>
                        <multiselect
                          placeholder=""
                          v-model="item.search"
                          :show-labels="false"
                          :options="brandTypeOptions"
                          :searchable="true"
                        ></multiselect>
                      </span>
                    </div>
                    <div
                      class="form-group form-select m-0 single-multiselect column-2"
                      v-if="item.field && item.field.id == 'level1'"
                    >
                      <span class="float-label w-100">
                        <label for="transaction">Level 1</label>
                        <multiselect
                          placeholder=""
                          v-model="item.search"
                          :show-labels="false"
                          :options="level1"
                          :searchable="true"
                        ></multiselect>
                      </span>
                    </div>
                    <div
                      class="form-group form-select m-0 single-multiselect column-2"
                      v-if="item.field && item.field.id == 'level2'"
                    >
                      <span class="float-label w-100">
                        <label for="transaction">Level 2</label>
                        <multiselect
                          placeholder=""
                          v-model="item.search"
                          :show-labels="false"
                          :options="level2"
                          :searchable="true"
                        ></multiselect>
                      </span>
                    </div>
                    <div v-if="advanceFilters.length > 1" class="column-3">
                      <b-button
                        class="fliter-btn btn-lg"
                        variant="outline-danger"
                        @click="removeFilter(index)"
                      >
                        <i class="fa fa-times" aria-hidden="true"></i>
                      </b-button>
                    </div>
                  </div>
                  <div class="text-left">
                    <b-button
                      class="fliter-btn w-auto"
                      variant="outline-primary"
                      @click="appendFilter"
                    >
                      <i class="fa fa-plus" aria-hidden="true"></i>
                      Add more filters
                    </b-button>
                  </div>
                </div>
                <div class="pb-3 pr-3 text-right">
                  <button
                    class="btn btn-primary w-auto"
                    @click="applyTestfilter"
                  >
                    Apply
                  </button>
                  <button
                    class="btn btn-outline-danger w-auto ml-3"
                    @click="clearTestfilter"
                  >
                    Cancel/Clear
                  </button>
                </div>
              </b-collapse>
            </div>
            <!-- displayed Filters -->
            <div
              class="filter-list-area d-flex flex-wrap align-items-center mb-1"
              v-if="displayFilters && displayFilters.length > 0"
            >
              <i
                class="fa fa-filter text-primary mr-1 mb-2"
                aria-hidden="true"
              ></i>
              <div
                class="mb-1"
                v-for="(item, index) in displayFilters"
                :key="index"
              >
                <label
                  class="font-14 line-height-18 mb-0 ml-2"
                  v-if="
                    index == 0 ||
                    item.filter_field != displayFilters[index - 1].filter_field
                  "
                >
                  {{ item.field_name + ":" }}
                </label>
                <span class="badge badge-warning-solid">
                  {{ item.filter_value ? item.filter_value : "-" }}
                  <i
                    class="fa fa-close cursor-pointer ml-1"
                    @click="removeFilter(index)"
                  ></i>
                </span>
              </div>
              <span class="text-danger cursor-pointer" @click="clearTestfilter">
                Clear all
              </span>
            </div>
            <!-- Table Pagination -->
            <div
              class="py-1 align-items-center justify-content-end table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="number-page">
                <b-pagination
                  class="pagination-small"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
            </div>
            <b-table
              responsive
              hover
              table-class="border"
              head-variant="light"
              :items="items"
              :fields="fields"
              :per-page="perPage"
              striped
            >
              <template #cell(country)="data">
                <div class="align-items-center d-flex">
                  <span class="ml-0" :class="data.value.flagClass"></span>
                  <span
                    class="ml-2"
                    v-b-tooltip.hover
                    :title="data.item.country.name"
                  >
                    {{ data.item.country.isocode.toUpperCase() }}
                  </span>
                </div>
              </template>
              <template #cell(bank_name)="data">
                {{ data.value }}
                <span
                  class="badge badge-danger ml-1"
                  v-if="data.item.whitelisted == 'No'"
                >
                  Blocked
                </span>
              </template>
              <template #cell(card_brand)="data">
                <img
                  width="40px"
                  :src="data.value.img"
                  v-b-tooltip.hover
                  :title="data.value.name"
                />
              </template>
              <template #cell(whitelisted)="data">
                <div class="custom-switch success-error-bg">
                  <input
                    type="checkbox"
                    class="custom-switch-input"
                    :id="`customSwitchemail${data.index}`"
                    v-model="data.value"
                    @change="whitelistAlert(data.value)"
                  />
                  <label
                    class="custom-switch-label"
                    :for="`customSwitchemail${data.index}`"
                  >
                    <span class="custom-switch-text1">Yes</span>
                    <span class="custom-switch-text2">No</span>
                  </label>
                </div>
              </template>
              <template #cell(action)>
                <b-dropdown
                  id="dropdown-1"
                  text="Actions"
                  size="sm"
                  right
                  variant="outline-primary"
                >
                  <b-dropdown-item @click="editBinNumber()">
                    Edit
                  </b-dropdown-item>
                  <b-dropdown-item @click="showAlert">Delete</b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
            <!-- Table Pagination -->
            <div
              class="py-3 align-items-center justify-content-between table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="per-page">
                <b-form-group
                  label="Per page"
                  label-for="per-page-select"
                  class="mb-0"
                >
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="number-page">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
              <div class="go-page">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Go To Page</span>
                  </div>
                  <input
                    type="text"
                    v-model="currentPageJump"
                    class="form-control"
                    value=""
                    @keyup.enter="onEnter"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const BreadCrumb = require("@/components/BreadCrumb.vue").default;
import { mapGetters } from "vuex";
export default {
  name: "BinListingComponent",
  components: {
    BreadCrumb,
    Multiselect: () => import("vue-multiselect"),
  },
  data() {
    return {
      fields: [
        { key: "country", label: "Country" },
        { key: "bin", label: "Bin" },
        { key: "bank_name", label: "Bank Name" },
        { key: "card_brand", label: "Card Brand" },
        { key: "type", label: "Type" },
        { key: "level1", label: "Level1" },
        { key: "level2", label: "Level2" },
        { key: "gateway_url", label: "Payment Provider" },
        { key: "whitelisted", label: "Whitelisted" },
        {
          key: "action",
          label: "Action",
          sortable: false,
          thClass: "th_sortfix text-right pr-4",
          tdClass: "text-right",
        },
      ],
      items: [
        {
          bin: "465910",
          bank_name: "LLOYDS BANK PLC",
          bank_brand: "---",
          card_brand: {
            name: "Visa",
            img: require(`@/assets/ecommerce/card-visa.png`),
          },
          type: "DEBIT",
          level1: "",
          level2: "",
          country: {
            flagClass: "flag-icon flag-icon-gb fi-lg fi-round",
            isocode: "gb",
            name: "United Kingdom",
          },
          gateway_url: "cashflows",
          whitelisted: true,
        },
        {
          bin: "543861",
          bank_name: "FINANCE INCORPORATED LTD",
          bank_brand: "---",
          card_brand: {
            name: "Master-Card",
            img: require(`@/assets/ecommerce/card-master.png`),
          },
          type: "PREPAID",
          level1: "",
          level2: "",
          country: {
            flagClass: "flag-icon flag-icon-gh fi-lg fi-round",
            isocode: "gh",
            name: "Ghana",
          },
          gateway_url: "cashflows",
          whitelisted: false,
        },
        {
          bin: "422222",
          bank_name:
            "BANCO MULTIPLE PROMERICA DE LA REPUBLICA DOMINICANA, S.A.",
          bank_brand: "---",
          card_brand: {
            name: "Visa",
            img: require(`@/assets/ecommerce/card-visa.png`),
          },
          type: "CREDIT",
          level1: "Personal",
          level2: "Standard",
          country: {
            flagClass: "flag-icon flag-icon-us fi-lg fi-round",
            isocode: "us",
            name: "United States",
          },
          gateway_url: "paysafe",
          whitelisted: true,
        },
        {
          bin: "491673",
          bank_name: "BANK OF AMERICA, N.A.",
          bank_brand: "---",
          card_brand: {
            name: "Amex",
            img: require(`@/assets/ecommerce/card-amex.png`),
          },
          type: "DEBIT",
          level1: "Personal",
          level2: "Standard",
          country: {
            flagClass: "flag-icon flag-icon-fr fi-lg fi-round",
            isocode: "FR",
            name: "France",
          },
          gateway_url: "cashflows",
          whitelisted: true,
        },
        {
          bin: "465901",
          bank_name: "BARCLAYS BANK PLC",
          bank_brand: "---",
          card_brand: {
            name: "Master-Card",
            img: require(`@/assets/ecommerce/card-master.png`),
          },
          type: "CREDIT",
          level1: "Personal",
          level2: "Standard",
          country: {
            flagClass: "flag-icon flag-icon-us fi-lg fi-round",
            isocode: "us",
            name: "United States",
          },
          gateway_url: "cashflows",
          whitelisted: true,
        },
        {
          bin: "555846",
          bank_name: "BANK OF AMERICA, N.A.",
          bank_brand: "---",
          card_brand: {
            name: "Amex",
            img: require(`@/assets/ecommerce/card-amex.png`),
          },
          type: "DEBIT",
          level1: "Personal",
          level2: "Standard",
          country: {
            flagClass: "flag-icon flag-icon-gb fi-lg fi-round",
            isocode: "gb",
            name: "United Kingdom",
          },
          gateway_url: "paysafe",
          whitelisted: true,
        },
        {
          bin: "453962",
          bank_name: "BANC INTERNACIONAL DANDORRA, S.A.",
          bank_brand: "---",
          card_brand: {
            name: "Visa",
            img: require(`@/assets/ecommerce/card-visa.png`),
          },
          type: "DEBIT",
          level1: "Personal",
          level2: "Standard",
          country: {
            flagClass: "flag-icon flag-icon-gb fi-lg fi-round",
            isocode: "gb",
            name: "United Kingdom",
          },
          gateway_url: "cashflows",
          whitelisted: true,
        },
      ],
      searchText: "",
      isVisibleFilter: false,
      displayFilters: [],
      brandOptions: [
        "VISA",
        "MASTERCARD",
        "PRIVATE LABEL ",
        "AMERICAN EXPRESS",
        "DISCOVER",
        "MAESTRO",
        "JCB",
        "NEWDAY",
        "VISA/DANKORT",
      ],
      brandTypeOptions: ["CREDIT", "DEBIT"],
      level1: ["Business", "Personal"],
      level2: ["Prepaid", "Standard"],

      filterField: [
        { id: "brand", name: "Card Brand", $isDisabled: false },
        { id: "type", name: "Card Type", $isDisabled: false },
        { id: "level1", name: "Level1", $isDisabled: false },
        { id: "level2", name: "Level2", $isDisabled: false },
      ],
      advanceFilters: [
        {
          field: { id: "brand", name: "Brand", $isDisabled: false },
          search: "",
        },
      ],
      totalRows: 0,
      currentPage: 1,
      currentPageJump: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, { value: 100, text: 100 }],
    };
  },
  methods: {
    whitelistAlert(type) {
      let temp = type ? "Whitelisted!" : "Blacklisted!";
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary btn-lg my-3",
          cancelButton: "btn btn-outline-secondary btn-lg",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You want to change?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
        })
        .then((result) => {
          if (result.isConfirmed) {
            swalWithBootstrapButtons.fire("", temp, "success");
          }
        });
    },
    editBinNumber() {
      this.$router.push({ path: "/list/edit-bin-listing" });
    },
    showAlert() {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary btn-lg my-3",
          cancelButton: "btn btn-outline-secondary btn-lg",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You want to delete this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            swalWithBootstrapButtons.fire(
              "Deleted!",
              "Your record has been deleted.",
              "success",
            );
          }
        });
    },
    // for openFilters
    openFilters() {
      if (this.advanceFilters == 0) {
        this.advanceFilters = [
          {
            field: { id: "brand", name: "Brand", $isDisabled: false },
            search: "",
          },
        ];
      }
      this.isVisibleFilter = !this.isVisibleFilter;
    },
    // apply filter
    applyTestfilter() {
      let params = [];
      this.advanceFilters.map((item) => {
        let data = {
          filter_field: item.field.id,
          field_name: item.field.name,
          filter_value: item.search,
        };
        params.push(data);
      });
      this.isVisibleFilter = false;
      this.$cookies.set("bin-listing-filter", params);
      this.displayFilters = this.$cookies.get("bin-listing-filter");
      console.log("params", params);
    },
    // clear filter
    clearTestfilter() {
      this.advanceFilters = [
        {
          field: { id: "brand", name: "Brand", $isDisabled: false },
          search: "",
        },
      ];
      this.filterField.map((item) => {
        item.$isDisabled = false;
      });
      this.displayFilters = [];
      this.isVisibleFilter = false;
      this.$cookies.set("bin-listing-filter", this.displayFilters);
    },
    // append filters
    appendFilter() {
      this.advanceFilters.map((item) => {
        this.filterField.filter(
          (data) => data.id == item.field.id,
        )[0].$isDisabled = true;
      });
      if (this.filterField.filter((data) => data.$isDisabled == false)[0]) {
        this.advanceFilters.push({
          field: this.filterField.filter(
            (data) => data.$isDisabled == false,
          )[0],
          search: "",
        });
        this.filterField.filter(
          (data) => data.$isDisabled == false,
        )[0].$isDisabled = true;
      }
    },
    // update fields of filters
    fieldsUpdate() {
      this.filterField.map((item) => {
        item.$isDisabled = false;
      });
      this.advanceFilters.map((item) => {
        this.filterField.filter(
          (data) => data.id == item.field.id,
        )[0].$isDisabled = true;
      });
    },
    // to remove filters
    removeFilter(index) {
      this.filterField.filter(
        (data) => data.id == this.advanceFilters[index].field.id,
      )[0].$isDisabled = false;
      this.advanceFilters.splice(index, 1);
      this.displayFilters.splice(index, 1);
      this.$cookies.set("bin-listing-filter", this.displayFilters);
    },
    cookieFilters() {
      this.displayFilters =
        this.$cookies.get("bin-listing-filter") != null
          ? this.$cookies.get("bin-listing-filter")
          : [];
      let filters = [];
      if (this.displayFilters && this.displayFilters.length > 0) {
        this.displayFilters.map((item) => {
          this.filterField.filter(
            (data) => data.id == item.filter_field,
          )[0].$isDisabled = true;
          if (item.filter_field == "brand") {
            filters.push({
              field: {
                id: item.filter_field,
                name: this.filterField.filter(
                  (data) => data.id == item.filter_field,
                )[0].name,
                $isDisabled: true,
              },
              search: this.brandOptions.filter(
                (data) => data == item.filter_value,
              )[0],
            });
          }
          if (item.filter_field == "type") {
            filters.push({
              field: {
                id: item.filter_field,
                name: this.filterField.filter(
                  (data) => data.id == item.filter_field,
                )[0].name,
                $isDisabled: true,
              },
              search: this.brandTypeOptions.filter(
                (data) => data == item.filter_value,
              )[0],
            });
          }
          if (item.filter_field == "level1") {
            filters.push({
              field: {
                id: item.filter_field,
                name: this.filterField.filter(
                  (data) => data.id == item.filter_field,
                )[0].name,
                $isDisabled: true,
              },
              search: this.level1.filter(
                (data) => data == item.filter_value,
              )[0],
            });
          }
          if (item.filter_field == "level2") {
            filters.push({
              field: {
                id: item.filter_field,
                name: this.filterField.filter(
                  (data) => data.id == item.filter_field,
                )[0].name,
                $isDisabled: true,
              },
              search: this.level2.filter(
                (data) => data == item.filter_value,
              )[0],
            });
          }
        });
        this.advanceFilters = filters;
      }
    },

    onEnter(e) {
      var paginationMenu = Math.ceil(this.totalRows / this.perPage);
      if (e.target.value > 0) {
        if (paginationMenu >= e.target.value) {
          this.currentPage = e.target.value;
        }
      }
    },
  },
  mounted() {
    this.totalRows = this.items.length;
    setTimeout(() => {
      // this.cookieFilters();
    }, 100);
  },
  computed: {
    ...mapGetters(["isLoading"]),
  },
};
</script>
